<ng-container [formGroup]="formGroupCampaign">

  <div class="position-relative mb-4">
    <label class="form-check-label form-check-label--paybee mb-1">Optional header in emails to donors</label>
    <mdb-form-control class="email-header mb-4" data-panel="eMail">
      <app-quill-custom mdbInput formControlName="greeting" limit="512" data-panel="eMail"></app-quill-custom>
    </mdb-form-control>   
  </div>

  <div class="position-relative mb-4">
    <label class="form-check-label form-check-label--paybee mb-1">Optional footer for emails to donors</label>
    <mdb-form-control class="mb-4">
      <app-quill-custom mdbInput formControlName="emailFooter" limit="2048"></app-quill-custom>
    </mdb-form-control>   
  </div>


  <div class="row justify-content-left">
    <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8 col-xl-8">
        <div>
            Add email addresses to be notified after each successful transaction
        </div>
        <p class="mb-0 grey-text small">
            Enter an email address then press return to add. Click <strong>X</strong> to remove it.
        </p>
        <app-chips 
          data-panel="eMail"
          [placeholder]="emailPlaceholder" 
          [elementPattern]="emailPattern" 
          formControlName="notifyTransactionEmails"
          idChips="notifyTransactionEmails"
          ></app-chips>

    </div>
  </div>
</ng-container>

